<template>
  <div class="ec-dashboard">
    <div ref="wrapper"></div>
  </div>
</template>
<script>
  import * as echarts from 'echarts'
  import { throttle } from '@/utils'
  export default {
    components: {},
    props: {
      ttXAxis: {
        type: Array,
      },
      ttCycleData: {
        type: Array,
      },
      ttTaktData: {
        type: Array,
      },
    },
    data() {
      return {
        myChart: null,
        option: {
          color: ['#5379ad'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'line', // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          legend: {
            top: 20,
            data: ['Cycle Time', 'TAKT Time'],
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10s%',
            containLabel: true,
          },
          xAxis: [
            {
              type: 'category',
              data: this.ttXAxis,
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                interval: 0,
                rotate: 30,
              },
              splitLine: {
                show: false,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: 'Cycle Time',
              type: 'bar',
              barWidth: '30%',
              data: this.ttCycleData,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#80a9fb' },
                    { offset: 0.5, color: '#5d8ceb' },
                    { offset: 1, color: '#46649f' },
                  ]),
                },
                emphasis: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: '#46649f' },
                    { offset: 0.7, color: '#5d8ceb' },
                    { offset: 1, color: '#80a9fb' },
                  ]),
                },
              },
            },
            {
              name: 'TAKT Time',
              type: 'line',
              data: this.ttTaktData,
              itemStyle: {
                normal: {
                  color: '#f60',
                },
              },
            },
          ],
        },
      }
    },
    watch: {
      ttTaktData: {
        handler() {
          setTimeout(() => {
            this.drawLine()
          }, 50)
        },
        immediate: true,
        deep: true,
      },
    },

    mounted() {
      this.drawLine()
      window.addEventListener('resize', throttle(this.resize, 500))
    },
    unmounted() {
      window.removeEventListener('resize', this.resize)
    },
    methods: {
      drawLine() {
        const myChart = echarts.init(this.$refs.wrapper)

        let option = { ...this.option }

        // const elHeight = this.$refs.wrapper.clientHeight
        option.series[0].data = this.ttCycleData
        option.series[1].data = this.ttTaktData
        option.xAxis[0].data = this.ttXAxis

        myChart.setOption(option, true)
      },
      resize() {
        if (!this.$refs.wrapper) return
        echarts.init(this.$refs.wrapper).resize()
        this.drawLine()
      },
    },
  }
</script>
<style lang="less" scoped>
  .ec-dashboard {
    & > div {
      width: 100%;
      height: 100%;
    }
  }
</style>
